import { render, staticRenderFns } from "./Select-Supplier.vue?vue&type=template&id=e28869dc&scoped=true"
import script from "./Select-Supplier.vue?vue&type=script&lang=js"
export * from "./Select-Supplier.vue?vue&type=script&lang=js"
import style0 from "./Select-Supplier.vue?vue&type=style&index=0&id=e28869dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28869dc",
  null
  
)

export default component.exports